import { Button } from '@mui/material';
import { ITechnician } from '../../../utils/entities/interface';
import {
  capitalizeWords,
  formatDate,
  formatTechnicianType,
} from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { RemoveRedEyeOutlined } from '@mui/icons-material';
import { ListTable } from '../../molecules/ListTable';
import { useState } from 'react';
import { ToggleTechnicianStatus } from '../../../services/technician';
import { ModalConfirmation } from '../../molecules/ModalConfirmation';

export const ContractorList = ({
  technicians,
  isLoading,
  onUpdate,
  headerCells,
}: {
  technicians: ITechnician[];
  headerCells: [string, number][];
  isLoading: boolean;
  onUpdate: () => void;
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const [selectedTechnician, setSelectedTechnician] =
    useState<ITechnician | null>(null);

  const handleClose = () => {
    setOpenModal(false);
    setSelectedTechnician(null);
  };

  const handleOpenModal = (technician: ITechnician) => {
    setSelectedTechnician(technician);
    setOpenModal(true);
  };

  const handleConfirmToggle = async () => {
    if (!selectedTechnician) return;
    await ToggleTechnicianStatus(selectedTechnician._id);
    onUpdate();
    handleCloseModal();
  };

  const handleCloseModal = () => {
    setSelectedTechnician(null);
    setOpenModal(false);
  };

  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      onClick: (technician: ITechnician) =>
        navigate(`/technicians/${technician._id}`),
    },
  ];

  return (
    <>
      <ListTable
        headerCells={headerCells}
        rows={technicians}
        isLoading={isLoading}
        actions={actions}
        renderCell={(technician: ITechnician, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return capitalizeWords(technician.name) || 'N/A';
            case 1:
              return '+91-' + technician.phoneNumber.slice(0, 10);
            case 2:
              return formatDate(technician.dob) || 'N/A';
            case 3:
              return formatTechnicianType(technician.type);
            case 4:
              return technician.experience || 'N/A';
            case 5:
              return capitalizeWords(technician.position);
            case 6:
              return (
                <Button
                  variant="outlined"
                  size="small"
                  color={
                    technician.status == 'AVAILABLE'
                      ? 'error'
                      : technician.status == 'KYC_PENDING'
                        ? 'warning'
                        : 'success'
                  }
                  onClick={() => {
                    if (technician.status !== 'KYC_PENDING')
                      handleOpenModal(technician);
                  }}
                  sx={{
                    textTransform: 'none',
                    fontSize: '0.8rem',
                    borderRadius: '8px',
                  }}
                >
                  {technician.status == 'AVAILABLE'
                    ? 'Disable'
                    : technician.status == 'KYC_PENDING'
                      ? 'Pending'
                      : 'Enable'}
                </Button>
              );
            default:
              return null;
          }
        }}
      />

      {/* Confirmation Modal */}
      <ModalConfirmation
        open={openModal}
        handleClose={handleClose}
        handleConfirm={handleConfirmToggle}
        selectedItem={selectedTechnician}
        entityName="technician"
      />
    </>
  );
};
